import React, { useState } from 'react';
import { api } from '../lib/api.js';
import { Alert, Field } from '../components/ui.jsx';

/** Reached from a one-time link. No session is needed, and the link works once. */
export default function ResetPassword() {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    if (password.length < 10) return setError('Use at least ten characters.');
    if (password !== confirm) return setError('The two entries do not match.');
    setBusy(true);
    try {
      await api.post('/api/auth/reset-password', { token, new_password: password });
      setDone(true);
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  };

  return (
    <div className="auth">
      <aside className="auth-art">
        <div className="inline"><div className="rail-mark">IV</div><b>InvIT</b></div>
        <h2>Set a new password.</h2>
        <div style={{ fontSize: 12.5, color: '#8f98a4' }}>
          Changing it also ends every session opened with the old one.
        </div>
      </aside>
      <div className="auth-form">
        <form className="inner" onSubmit={submit}>
          <h1>New password</h1>
          <Alert>{error}</Alert>
          {done ? (
            <>
              <Alert kind="ok">Password changed. You can sign in now.</Alert>
              <a className="btn big" style={{ width: '100%', justifyContent: 'center' }} href="/">Go to sign in</a>
            </>
          ) : (
            <>
              {!token && <Alert kind="warn">This link is missing its token. Ask for a new one.</Alert>}
              <Field label="New password" hint="at least 10 characters">
                <input type="password" autoComplete="new-password" value={password} autoFocus
                  onChange={(e) => setPassword(e.target.value)} required />
              </Field>
              <Field label="Repeat it">
                <input type="password" autoComplete="new-password" value={confirm}
                  onChange={(e) => setConfirm(e.target.value)} required />
              </Field>
              <button className="btn big" style={{ width: '100%', justifyContent: 'center' }} disabled={busy || !token}>
                {busy ? 'Saving…' : 'Set password'}
              </button>
            </>
          )}
        </form>
      </div>
    </div>
  );
}
